import styled from "styled-components";

export const AlertMsgContainer = styled.div`
  width: calc(100% - 4px);
  height: 64px;
  border: 2px solid #be2f25;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin: 16px 0;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;

    p {
      padding: 4px;
      font-size: 8px;
    }
  }
`;

export const MessageContainer = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Message = styled.p`
  font-size: ${({ font }) => font};
  text-transform: uppercase;
  color: ${({ messageColor }) => messageColor};
  padding-left: 16px;
  font-weight: bold;
  margin: 0;
  margin-top: ${({ marginTop }) => marginTop};
  @media (max-width: 768px) {
    padding: 4px;
    font-size: 8px;
  }
`;

export const Icon = styled.div`
  height: 100%;
  width: 100px;
  padding: 0 24px;
  background-color: #be2f25;
  span {
    text-transform: uppercase;
    color: #fff;
    font-size: 14px;
  }
  svg {
    margin-right: 8px;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 4px;
    span {
      font-size: 10px;
    }
  }
`;
